import { CircularProgress, Grid, InputLabel, makeStyles, Typography } from '@material-ui/core';
import MyCollapse from 'components/Collapse';
import CustomCopyToClipboard from 'components/CustomCopyToClipboard';
import React, { Fragment, memo, useMemo } from 'react';

import type { ISubscriptionInvoice, ISubscriptions } from 'v2/interfaces/subscriptions';
interface IProps {
  isLoading: boolean;
  invoices: ISubscriptionInvoice[];
  contract: ISubscriptions;
}
const useStyles = makeStyles(() => ({
  center: {
    display: 'flex',
    justifyContent: 'center',
  },
  container: {
    padding: 8,
  },
}));

const Recovery = memo(({ isLoading, invoices, contract }: IProps) => {
  const classes = useStyles();

  const renderView = useMemo(() => {
    if (isLoading) {
      return (
        <div className={classes.center}>
          <CircularProgress size={22} />
        </div>
      );
    }

    if (!invoices.length) {
      return (
        <div className={classes.center}>
          <Typography variant='body2'>Nenhuma fatura encontrada</Typography>
        </div>
      );
    }

    if (!invoices[invoices.length - 1].checkout_recovery_link && !invoices[invoices.length - 1].bankslip_url) {
      return (
        <div className={classes.center}>
          <Typography variant='body2'>Não há links</Typography>
        </div>
      );
    }

    const isInternational = !!(contract?.currency && contract?.currency !== 'BRL');

    return (
      <>
        {invoices[invoices.length - 1].checkout_recovery_link && (
          <Grid xs={12}>
            <InputLabel htmlFor='link_alt' style={{ fontSize: 12 }}>
              Link de Alteração de Pagamento
            </InputLabel>
            <div className='m8' />
            <CustomCopyToClipboard fullWidth text={invoices[invoices.length - 1].checkout_recovery_link} disableUnderline={true} />
            <div className='m8' />
          </Grid>
        )}

        {invoices[invoices.length - 1].bankslip_url && !isInternational && (
          <Grid xs={12}>
            <InputLabel htmlFor='boleto_pag' style={{ fontSize: 12 }}>
              Boleto para Pagamento
            </InputLabel>
            <div className='m8'></div>
            <CustomCopyToClipboard fullWidth text={invoices[invoices.length - 1].bankslip_url} disableUnderline={true} />
          </Grid>
        )}
      </>
    );
  }, [classes.center, invoices, isLoading, contract]);

  return (
    <MyCollapse title='Recuperação' arrow noPadding>
      <div className={classes.container}>{renderView}</div>
    </MyCollapse>
  );
});

export default Recovery;
